import { useTranslation } from "react-i18next";
import {
  Barcode,
  Book,
  CalendarSearch,
  MessagesIcon,
  People,
} from "shared/components/Icons";
import { Urls } from "shared/constants/url";

const ReturnerData = () => {
  const { t } = useTranslation();
  const data = [
    {
      id: 1,
      title: t("HUBDev"),
      url: Urls.HUBDEV_URL,
      icon: <Book />,
      text: t("libraryDescription"),
      img: "/media/rocket.gif",
    },
   {
  id: 8, 
  title: "Diversity, Equity & Inclusion",
  externalUrl: "https://pashaholding.btsmomenta.com/#/auth/sso/exerceo/pashaholding/DEI", 
  openInNewTab: true,
  icon: <CalendarSearch />,
  isNew: false,
  img: "/media/diversity.gif",
},
    {
      id: 2,
      title: t("discussion"),
      url: Urls.DISCUSSIONS_URL,
      icon: <MessagesIcon />,
      text: t("discussionsDescription"),
      img: "/media/customer.gif",
    },
     {
      id: 7,
      title: `${t("skillsMastery")} (beta)`,
      url: Urls.MENTORS_URL,
      icon: <CalendarSearch />,
      isNew: true,
      img: "/media/mentorship.gif",
    },
    {
      id: 3,
      title: t("community"),
      url: Urls.COMMUNITY_URL,
      icon: <People />,
      text: t("communityDescription"),
      img: "/media/diagram.gif",
    },
    {
      id: 4,
      title: t("news"),
      url: Urls.NEWS_URL,
      icon: <Barcode />,
      text: t("newsDescription"),
      img: "/media/live.gif",
    },

    {
      id: 5,
      title: t("events"),
      url: Urls.EVENTS_URL,
      icon: <CalendarSearch />,
      text: t("eventsDescription"),
      img: "/media/calendar.gif",
    },

    {
      id: 6,
      title: t("trainers"),
      url: Urls.TRAINER_URL,
      icon: <CalendarSearch />,
      isNew: false,
      // text: t("eventsDescription"),
      img: "/media/swimming.gif",
    },
   
   
  ];

  return {
    data,
  };
};
export default ReturnerData;
